import { combineReducers } from "redux";
import { CaptchaReducer } from "./captcha/reducer";
import { captchaInitialState, CaptchaState } from "./captcha/state";
import { CustomerReducer } from "./customer/reducer";
import { customerDefaultState, CustomerState } from "./customer/state";
import { LegalRepresentativePopupReducer } from "./legal-representative-popup/reducer";
import {
    legalRepresentativePopupDefaultState,
    LegalRepresentativePopupState,
} from "./legal-representative-popup/state";
import { PageReducer } from "./page/reducer";
import { pageDefaultState, PageState } from "./page/state";
import { QuotationPopupReducer } from "./quotation-popup/reducer";
import {
    QuotationPopupState,
    quotationStateDefaultState,
} from "./quotation-popup/state";
import { QuotationReducer } from "./quotation/reducer";
import { quotationDefaultState, QuotationState } from "./quotation/state";
import { PreQuotationReducer } from "./pre-quotation/reducer";
import {
    preQuotationDefaultState,
    PreQuotationState,
} from "./pre-quotation/state";
import { QuotationPaymentReducer } from "./quotation-payment/reducer";
import {
    QuotationPaymentState,
    quotationPaymentDefaultState,
} from "./quotation-payment/state";
import { PayrollFileReducer } from "./payroll-file/reducer";
import {
    payrollFileDefaultState,
    PayrollFileState,
} from "./payroll-file/state";
import { EmissionReducer } from "./emission/reducer";
import { emissionDefaultState, EmissionState } from "./emission/state";
import { zohoDefaultState, ZohoState } from "./zoho/state";
import { ZohoReducer } from "./zoho/reducer";

export default combineReducers({
    quotationPopup: QuotationPopupReducer,
    captcha: CaptchaReducer,
    page: PageReducer,
    legalRepresentativePopup: LegalRepresentativePopupReducer,
    customer: CustomerReducer,
    quotation: QuotationReducer,
    preQuotation: PreQuotationReducer,
    quotationPayment: QuotationPaymentReducer,
    payroll_file: PayrollFileReducer,
    emission: EmissionReducer,
    zoho: ZohoReducer,
});

export const initialRootState: RootState = {
    quotationPopup: quotationStateDefaultState,
    captcha: captchaInitialState,
    page: pageDefaultState,
    legalRepresentativePopup: legalRepresentativePopupDefaultState,
    customer: customerDefaultState,
    quotation: quotationDefaultState,
    preQuotation: preQuotationDefaultState,
    quotationPayment: quotationPaymentDefaultState,
    payroll_file: payrollFileDefaultState,
    emission: emissionDefaultState,
    zoho: zohoDefaultState,
};

export type RootState = {
    quotationPopup: QuotationPopupState;
    captcha: CaptchaState;
    page: PageState;
    legalRepresentativePopup: LegalRepresentativePopupState;
    customer: CustomerState;
    quotation: QuotationState;
    preQuotation: PreQuotationState;
    quotationPayment: QuotationPaymentState;
    payroll_file: PayrollFileState;
    emission: EmissionState;
    zoho: ZohoState;
};
